import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { ApiModule } from '@anduin/api';
import { ConfigModule } from '@anduin/config';
import { SharedModule } from '@anduin/shared';
import { PaymentRefundConfirmModalComponent, PaymentRefundSuccessModalComponent } from './components';

@NgModule({
  declarations: [PaymentRefundConfirmModalComponent, PaymentRefundSuccessModalComponent],
  imports: [
    ApiModule,
    SharedModule,
    CommonModule,
    ConfigModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    MatRadioModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatProgressBarModule,
    DragDropModule,
    SharedModule,
    MatDialogModule,
    MatCheckboxModule,
  ],
  exports: [PaymentRefundConfirmModalComponent, PaymentRefundSuccessModalComponent],
})
export class CommonPaymentsModule {}
